/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-09-04 14:38:02
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-11-24 16:52:52
 */
import request from '@/utils/request'

export function getLists(data) {
  return request({
    url: '/icps/system/sign/cloudSell/economicBenefit/getLists', 
    method: 'post',
	data
  })
}
export function deletes(data) {
  return request({
    url: '/icps/system/sign/cloudSell/economicBenefit/deletes', 
    method: 'post',
	data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/cloudSell/economicBenefit/saveOrUpdate', 
    method: 'post',
    data
  })
}
/**
 * @Description: 获取销量
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getSaleNumber(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/getsum', 
    method: 'post', 
    data
  })
}
